<template>
  <span>
    <v-select :value="modelValue" :options="orgList" @search="loadOrgList" @input="changeCallback"
    placeholder="Search for Institution..."></v-select>
  </span>
</template>

<script>
  import vSelect from './SelectComponent.vue'
  import Notifier from '../common/Notifier'
  import CommonDataService from '../endpoints/CommonDataService'
  import { debounce } from 'lodash'

  export default {
    emits: ['update:modelValue','change'],
    name: 'org-input',
    components: {vSelect},

    props: ['modelValue'],
    data () {
      return {
        orgList: [],
        selected: this.modelValue
      }
    },
    methods: {
      loadOrgList: debounce(function (search, loading) {
        loading(true)
        let self = this

        CommonDataService.searchOrgs(search)
          .then(response => {
            self.orgList = response.data
            loading(false)
          })
          .catch(error => {
            loading(false)
            Notifier.error(error.message)
          })
      }, 500),
      changeCallback (val) {
        this.$emit('update:modelValue', val ? parseInt(val.value) : null)
        this.$emit('change', val ? parseInt(val.value) : null)
      }
    }
  }
</script>
